import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch, Redirect } from 'react-router-dom'

import { datadogRum } from '@datadog/browser-rum'
import _ from 'lodash'

import AdminRoutes from '../containers/App'
import Login from '../containers/Login/Login'
import Logout from '../containers/Logout/Logout'
import PasswordRecovery from '../containers/PasswordRecovery/PasswordRecovery'
import GeneratedReport from '../containers/Reports/ReportsGeneration/GeneratedReport'
import FarmersPortal from '../containers/FarmersPortal'
import Version from '../containers/Version'
import { history } from '../appRedux/store'
import { matchRoutes } from '../util/matchRoutes'

const rumRoutes = [
  { path: '/', exact: true },
  { path: '/login', exact: true },
  { path: '/reports', exact: true },
  { path: '/actions' }
]

const Routes = function () {
  const auth = useSelector((state) => state.auth.auth)
  const { location } = history

  useEffect(() => {
    // matchRoutes was manually implemented here because new versions of react-router-dom (>=v6)
    // already has this function available. When possible, replace it with the function available
    // in the react-router-dom package
    const routeMatches = matchRoutes(rumRoutes, location)
    const viewName = routeMatches && computeViewName(routeMatches)
    if (viewName) {
      datadogRum.startView({ name: viewName })
    }
  }, [location.pathname])

  return (
    <Switch>
      <Route path="/version" component={Version} />
      <Route path="/logout" component={Logout} />
      <Route path="/password-recovery" component={PasswordRecovery} />
      <Route path="/generated-report" component={GeneratedReport} />
      <Route path="/farmers/:path" component={FarmersPortal} />
      {!_.get(auth, 'token') && (
        <>
          <Route path="/login" component={Login} />
          <Route path="/" component={Login} />
        </>
      )}
      {_.get(auth, 'token') && (
        <>
          <Route path="/login">
            <Redirect to="/dashboard" />
          </Route>
          <Route path="/" component={AdminRoutes} />
        </>
      )}
    </Switch>
  )
}

// Compute view name out of routeMatches
function computeViewName(routeMatches) {
  let viewName = ''
  for (let index = 0; index < routeMatches.length; index++) {
    const routeMatch = routeMatches[index]
    const path = routeMatch.path
    // Skip pathless routes
    if (!path) {
      continue
    }

    if (path.startsWith('/')) {
      // Handle absolute child route paths
      viewName = path
    } else {
      // Handle route paths ending with "/"
      viewName += viewName.endsWith('/') ? path : `/${path}`
    }
  }

  return viewName || '/'
}

export default Routes
